export default "__VITE_ASSET__CIgbaf4m__"